module.exports = __webpack_public_path__ + "img/LogoLight.79d48dce.svg";